import * as React from "react";

type HeaderColor = "blue" | "red" | "yellow";

interface ModalCardProps {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
  headerColor?: HeaderColor;
}

const headerColorMap: Record<HeaderColor, string> = {
  blue: "bg-[#0099FE]",
  red: "bg-[#FE0000]",
  yellow: "bg-[#FE9400]",
};

export default function ModalCard({
  title,
  onClose,
  children,
  className = "",
  headerColor = "blue",
}: ModalCardProps) {
  const bgColor = headerColorMap[headerColor];

  return (
    <div className={`bg-black ${className}`}>
      <header
        className={`flex justify-between items-center pl-[20px] pr-[20px] pt-[12px] pb-[12px] ${bgColor}`}
      >
        <div className="text-[33px] text-uppercase">
          <span>{title}</span>
        </div>
        <div
          className="w-[29px] h-[29px] hover:cursor-pointer"
          onClick={onClose}
        >
          <img src="/assets/cancel.svg" alt="cancel" />
        </div>
      </header>
      {children}
    </div>
  );
}
